/***
 *  MIT License
    Copyright (c) 2020 Mo Gorhom
    @see : https://github.com/gorhom/react-native-portal
 */
const ACTIONS = {
    REGISTER_HOST :"REGISTER_HOST",
    DEREGISTER_HOST:"DEREGISTER_HOST",
    ADD_UPDATE_PORTAL:"ADD_UPDATE_PORTAL",
    REMOVE_PORTAL:"REMOVE_PORTAL",
  }
  
  const INITIAL_STATE = {};
  
  export { ACTIONS, INITIAL_STATE };